/**
 * @type {import("gatsby").GatsbyBrowser['onRouteUpdate']}
 */
export const onRouteUpdate = function({ location }) {
  // eslint-disable-next-line
  if (process.env.NODE_ENV === `production` && typeof ym === 'function') {
    // eslint-disable-next-line
    ym(52292254, 'hit', (location || {}).pathname);
  }

  // eslint-disable-next-line
  if (process.env.NODE_ENV === 'production' && typeof gtag === 'function') {
    // eslint-disable-next-line
    gtag('config', 'UA-134155805-1', {
      page_path: (location || {}).pathname,
    });
  }
};
